import { InferType, number, object } from "yup";
import { OutcomeSchema } from ".";

export const DateVarianceSchema = object({
  ninety_days_or_less: OutcomeSchema.required(),
  over_ninety_days: OutcomeSchema.required(),
});

export const InstanceCountSchema = object({
  one_instance: OutcomeSchema.required(),
  two_or_more_instances: OutcomeSchema.required(),
});

export const EmploymentVerificationCriteriaSchemaV1 = object({
  version: number().required(),
  ruleset: object({
    mismatch_count: InstanceCountSchema.required(),
    date_variance: DateVarianceSchema.required(),
    unverified_employment_count: InstanceCountSchema.required(),
  }).required(),
});

export function isValidEmploymentVerificationCriteria(
  criteria: unknown
): criteria is InferType<typeof EmploymentVerificationCriteriaSchemaV1> {
  try {
    EmploymentVerificationCriteriaSchemaV1.validateSync(criteria);
    return true;
  } catch (error) {
    console.error("Invalid Employment Verification Criteria:", error);
    return false;
  }
}

// Export inferred types from schemas
export type DateVariance = InferType<typeof DateVarianceSchema>;
export type InstanceCount = InferType<typeof InstanceCountSchema>;
